module.exports = __webpack_public_path__ + "@/assets/img/logo-facebook.80b411b5.png";